import { useTranslation } from "react-i18next";

import { Box, Divider, NavLink, ScrollArea } from "@mantine/core";
import { useParams } from "@tanstack/react-router";

import { useCurrentWorkspace } from "@/api/resources/workspaces/hooks";
import DeploymentSelectorGlobal from "@/components/Deployment/DeploymentSelectorGlobal";
import NavbarListItem from "@/components/Navbar/NavbarListItem";
import {
  isNavigationGroup,
  useNavigationElementsDeployment,
  useNavigationElementsWorkspace,
} from "@/components/Navbar/useNavigationElements";
import WorkspaceSelectorGlobal from "@/components/Workspace/WorkspaceSelectorGlobal";
import { LAYOUT_NAVBAR_WIDTH } from "@/configs/layout";
import { useIsMobile } from "@/hooks/useIsMobile";
import { BusinessType } from "@/supabase.types";

interface Props {
  onClose?: () => void;
}
export const NavbarList = ({ onClose }: Props) => {
  const { t } = useTranslation();
  const { isTablet } = useIsMobile();
  const { workspace_id } = useParams({ strict: false });
  const { data: currentWorkspace } = useCurrentWorkspace();

  let canManageChildWorkspaces = false;
  if (currentWorkspace?.business_type === BusinessType.service_provider) {
    canManageChildWorkspaces = true;
  }
  if (currentWorkspace?.business_type === BusinessType.manufacturer) {
    canManageChildWorkspaces = true;
  }

  const navigationElementsWorkspace = useNavigationElementsWorkspace(workspace_id, canManageChildWorkspaces);
  const navigationElementsDeployment = useNavigationElementsDeployment(workspace_id);

  if (!workspace_id) return null;

  return (
    <ScrollArea.Autosize>
      {isTablet && (
        <Box p="sm">
          <WorkspaceSelectorGlobal onSelect={onClose} />
        </Box>
      )}
      <Divider my="xs" px="xs" label={t("workspace")} />
      {navigationElementsWorkspace.map((navElement) => {
        if (isNavigationGroup(navElement)) {
          return (
            <NavLink key={navElement.title} label={navElement.title} leftSection={navElement.icon}>
              {navElement.items.map((navElementChild) => (
                <NavbarListItem key={navElementChild.title} navigationItem={navElementChild} onClose={onClose} />
              ))}
            </NavLink>
          );
        }
        return <NavbarListItem key={navElement.title} navigationItem={navElement} onClose={onClose} />;
      })}

      <Divider my="xs" px="xs" label={t("deployment")} />

      <Box p="sm" maw={LAYOUT_NAVBAR_WIDTH}>
        <DeploymentSelectorGlobal />
      </Box>

      {navigationElementsDeployment.map((navElement) => {
        if (isNavigationGroup(navElement)) {
          return (
            <NavLink key={navElement.title} label={navElement.title} leftSection={navElement.icon}>
              {navElement.items.map((navElementChild) => (
                <NavbarListItem key={navElementChild.title} navigationItem={navElementChild} onClose={onClose} />
              ))}
            </NavLink>
          );
        }
        return <NavbarListItem key={navElement.title} navigationItem={navElement} onClose={onClose} />;
      })}
    </ScrollArea.Autosize>
  );
};

export default NavbarList;
